import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const useCreatePasswordSchema = () => {
  const { t } = useTranslation();
  return Yup.object().shape({
    password: Yup.string()
      .min(8, t("password_must_be_at_least_8_chars"))
      .matches(/[A-Z]/, t("password_must_contain_at_least_one_capital_letter"))
      .matches(/\d/, t("password_must_contain_at_least_one_number"))
      .required(t("password_required")),
  });
};

export default useCreatePasswordSchema;
